import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';

@AutoUnsubscribe()
@Component({
  selector: 'delete-list-confirm-component',
  templateUrl: './delete-list-confirm.component.html',
  styleUrls: ['./delete-list-confirm.component.scss']
})

export class DeleteListConfirmComponent {

  @Input() data: any;

  constructor(public modalsService: ModalsService, public sharedService: SharedService) { }

  ngOnDestroy() { }

  confirm() {
    this.sharedService.sendMessage('DELETE_LIST_CONFIRM', this.data);
    this.modalsService.hideModal();
  }

}
